import axios from "axios";

export default {
  namespaced: true,
  strict: true,
  state: {
    forgotEmailSent: false,
    resetPassword: {
      userID: "",
      resetPasswordError: false,
      tokenRetrievalError: false,
      Success: false,
    },
  },
  getters: {
    getEmailSent(state) {
      return state.forgotEmailSent;
    },
    getResetUserID(state) {
      return state.resetPassword.userID;
    },
    getResetPasswordError(state) {
      return state.resetPassword.resetPasswordError;
    },
    getResetPasswordSuccess(state) {
      return state.resetPassword.Success;
    },
    getTokenRetrievalError(state) {
      return state.resetPassword.tokenRetrievalError;
    },
  },
  mutations: {
    setForgotEmailSent(state, payload) {
      state.forgotEmailSent = payload;
    },
    setResetUserID(state, payload) {
      state.resetPassword.userID = payload.userID;
    },
    setResetPasswordError(state, payload) {
      state.resetPassword.resetPasswordError = payload;
    },
    setTokenRetrievalError(state, payload) {
      state.resetPassword.tokenRetrievalError = payload;
    },
    setResetPasswordSuccess(state, payload) {
      state.resetPassword.Success = payload;
    },
  },
  actions: {
    async postForgotPassword(state, payload) {
      //call POST on /forgot
      let json = { userID: payload.userId };
      try {
        await axios.post("forgot", json);
      } catch (err) {
        //nothing goes here
      }
    },
    setEmailSent(state, payload) {
      //no fire off to back end here
      state.commit("setForgotEmailSent", payload);
    },
    async getResetPasswordUserID(state, payload) {
      //call to GET on /forgot
      let data = {
        Token: payload.Token,
      };
      axios
        .get("forgot", { params: data })
        .then((res) => {
          if (res.status == 200) {
            state.commit("setResetUserID", res.data);
            state.commit("setTokenRetrievalError", false);
          }
        })
        .catch(() => {
          state.commit("setTokenRetrievalError", true);
        });
    },
    async putResetPassword(state, payload) {
      let json = {
        password: payload.password,
      };
      await axios
        .put("forgot", json)
        .then((res) => {
          state.commit("setResetPasswordSuccess", res.status == 200);
          state.commit("setResetPasswordError", res.status != 200);
        })
        .catch(() => {
          //set error
          state.commit("setResetPasswordError", true);
        });
    },
    reset(state) {
      state.commit("setForgotEmailSent", false);
      state.commit("setResetUserID", "");
      state.commit("setResetPasswordError", false);
      state.commit("setTokenRetrievalError", false);
      state.commit("setResetPasswordSuccess", false);
    },
  },
};
